import React from 'react';
import MoveLarge from 'wix-ui-icons-common/system/MoveLarge';
import colors from '../../Foundation/stylable/colors.st.css';

var DragHandle = function DragHandle() {
  return /*#__PURE__*/React.createElement(MoveLarge, {
    style: {
      color: colors.D80
    }
  });
};

DragHandle.displayName = 'MediaOverlay.DragHandle';
export default DragHandle;